import React from 'react';
import { FormattedMessage } from 'react-intl';
// eslint-disable-next-line import/no-cycle
import { SortableColumnKey, ShipmentColumnSortByKey } from './types';
import { SortByOptionType } from '../CustomizableTable/types';

const createSortByOptions = (key: string, values: ShipmentColumnSortByKey[]) =>
  values.map((value) => ({
    label: <FormattedMessage id={`shipments.table.sort-by.${key}.${value}`} />,
    value,
  }));

export const SHIPMENTS_SORT_BY_OPTIONS_MAP: Partial<
  Record<SortableColumnKey, SortByOptionType[] | ShipmentColumnSortByKey>
> = {
  [SortableColumnKey.Order]: createSortByOptions(SortableColumnKey.Order, [
    'order_created_at',
    'platform_order_number',
  ]),
  [SortableColumnKey.Package]: createSortByOptions(SortableColumnKey.Package, [
    'parcels_package_names_for_sorting',
    'parcels_count',
    'total_actual_weight',
  ]),
  [SortableColumnKey.Item]: createSortByOptions(SortableColumnKey.Item, [
    'shipment_items_count',
    'unique_sku_count',
    'total_customs_value',
  ]),
  [SortableColumnKey.Receiver]: createSortByOptions(SortableColumnKey.Receiver, [
    'destination_name',
    'destination_country_simplified_name',
    'postal_code',
    'state',
  ]),
  [SortableColumnKey.Courier]: createSortByOptions(SortableColumnKey.Courier, [
    'courier_display_name',
    'estimated_delivery_time',
  ]),
  [SortableColumnKey.Tracking]: 'courier_tracking_rating',
  [SortableColumnKey.CollectStatus]: 'collect_state',
  [SortableColumnKey.ImportTaxAndDuty]: 'import_tax_and_duty_sort_order',
  [SortableColumnKey.TotalCost]: 'total_charge',
} as const;

export const SortBySortableColumnKeyMap = Object.entries(SHIPMENTS_SORT_BY_OPTIONS_MAP).reduce(
  (acc, [key, values]) => {
    if (Array.isArray(values)) {
      values.forEach((value) => {
        acc[value.value as string] = key;
      });
    } else {
      acc[values] = key;
    }
    return acc;
  },
  {} as Record<string, string>
);
